module.exports = __webpack_public_path__ + "static/media/solarPannelWrong.75db3254.png";